import { useTranslation } from 'react-i18next';
import type { SplashModule } from 'types/capi/modules';

import AppleIcon from '~/assets/icons/Apple';
import StarFull from '~/assets/icons/StarFull';
import SplashImage from '~/components/SplashImage';
import Tracked from '~/components/Tracked';
import useRegion from '~/hooks/useRegion';

type Props = { module: SplashModule };

export default function Splash({ module }: Props) {
  const region = useRegion();

  return (
    <div className="relative h-[406px] w-full md:h-[506px]">
      <SplashImage
        imageDesktop={module.image_desktop}
        imageMobile={module.image_mobile}
        alt="home-page-splash-image"
      />
      <div className="flex h-full flex-col gap-4 pt-4 md:mx-auto md:max-w-desktop md:justify-center md:pt-0">
        <Text />
        {region.code === 'GB' && <Ratings />}
      </div>
    </div>
  );
}

function Text() {
  const { t } = useTranslation('home');

  return (
    <div className="relative flex w-full justify-start max-md:px-4">
      <div className="flex max-w-md flex-col gap-2 bg-dark-background/65 p-6 tracking-wide">
        <p className="text-3xl text-white md:text-5xl md:leading-tight">
          {t('splashTitle')}
        </p>
        <p className="whitespace-pre-line text-2xl text-golden-syrup md:text-3xl md:leading-tight">
          {t('splashSubheading')}
        </p>
      </div>
    </div>
  );
}

function Ratings() {
  const region = useRegion();
  if (region.code !== 'GB') return null;

  return (
    <div className="relative flex max-w-md flex-col items-start gap-2 max-md:mx-4 md:flex-row md:gap-6">
      <AppleRating />
    </div>
  );
}

function AppleRating() {
  return (
    <Tracked.ExternalLink
      name="DOWNLOAD_THE_APP"
      pagePosition="Homepage Splash"
      href="https://thesolesupplier.onelink.me/BPkz/qiopvew9"
      target="_blank"
      rel="noreferrer"
      variant="none"
    >
      <div className="flex items-center gap-4 bg-black px-3 py-1.5 text-white md:px-4 md:py-2">
        <div className="flex max-w-sm items-center gap-1 whitespace-nowrap text-sm">
          <AppleIcon colour="white" height="15" width="15" />
          App Store
        </div>
        <div className="mt-0.5 flex gap-0.5">
          <StarFull fill="#FA0" height="16" width="16" />
          <StarFull fill="#FA0" height="16" width="16" />
          <StarFull fill="#FA0" height="16" width="16" />
          <StarFull fill="#FA0" height="16" width="16" />
          <StarFull fill="#FA0" height="16" width="16" />
        </div>
      </div>
    </Tracked.ExternalLink>
  );
}
